import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useRef, useState } from 'react';
import throttle from 'lodash/throttle';
import { mappedMessangerNames } from "../config";
import { ymPushChatIconHide, ymPushChatIconOpen, ymPushChatScreenViewed, ymPushChatStart, ymPushChatView, ymPushClickChatClose, ymPushClickChatOpen, ymPushCloseChat, ymPushFaqItemViewed, ymPushMenuView, ymPushMessangerButton } from "./ym";
export var useChatOpenAnalytics = function useChatOpenAnalytics(isOpen, zoneType) {
  var isNotStart = useRef();
  useEffect(function () {
    if (isOpen) {
      ymPushChatScreenViewed();
      ymPushChatView(zoneType);
      isNotStart.current = true;
    } else if (isNotStart.current) {
      ymPushCloseChat();
      ymPushClickChatClose(zoneType);
    }
  }, [isOpen]);
};
export var useMenuAnalytic = function useMenuAnalytic(_ref) {
  var isChatOpen = _ref.isChatOpen,
    isMenuOpen = _ref.isMenuOpen,
    _ref$messengers = _ref.messengers,
    messengers = _ref$messengers === void 0 ? [] : _ref$messengers,
    zoneType = _ref.zoneType;
  var isNotStart = useRef();
  useEffect(function () {
    if (messengers.length > 1) {
      if (isMenuOpen) {
        ymPushMenuView(zoneType);
        ymPushChatIconOpen();
        ymPushClickChatOpen(zoneType);
        isNotStart.current = true;
      } else if (isNotStart.current) {
        ymPushChatIconHide();
      }
    }
  }, [messengers, isMenuOpen]);
  useEffect(function () {
    if ((messengers === null || messengers === void 0 ? void 0 : messengers.length) === 1 && isChatOpen) {
      ymPushChatIconOpen();
      ymPushClickChatOpen(zoneType);
      var toggleName = typeof messengers[0] === 'string' ? messengers[0] : messengers[0].featureToggle;
      var messenger = mappedMessangerNames[toggleName];
      ymPushMessangerButton(messenger);
    }
  }, [messengers, isChatOpen]);
};
export var useChatStartAnalytics = function useChatStartAnalytics() {
  return ymPushChatStart;
};
export var useViewFaqItemsAnalytics = function useViewFaqItemsAnalytics() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    visibleFaqItems = _useState2[0],
    setVisibleFaqItems = _useState2[1];
  var setFaqItemVisibility = useCallback(function (title, isVisible) {
    setVisibleFaqItems(function (prevVisibleFaqItems) {
      return isVisible ? [].concat(_toConsumableArray(prevVisibleFaqItems), [title]) : prevVisibleFaqItems.filter(function (item) {
        return item !== title;
      });
    });
  }, []);
  var throttledSendAnalytics = throttle(function (faqItems) {
    ymPushFaqItemViewed(faqItems);
  }, 1000);
  var handleSendFaqAnalytics = useCallback(throttledSendAnalytics, []);
  useEffect(function () {
    if (visibleFaqItems.length) {
      handleSendFaqAnalytics(visibleFaqItems);
    }
  }, [visibleFaqItems]);
  return setFaqItemVisibility;
};
export var useAnalytics = function useAnalytics(params) {
  useMenuAnalytic(params);
  useChatOpenAnalytics(params.isChatOpen, params.zoneType);
};